import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return <section className="not-found shell"><span>404</span><h1>Esta página ainda não existe.</h1><p>O endereço pode ter mudado ou o conteúdo ainda está em preparação.</p><Link to="/"><ArrowLeft size={18} /> Voltar ao início</Link></section>;
}
